<div class="card sales-1 overflow-hidden rounded-10 shadow">
  <div class="card-body" style="min-height: 133px !important" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-top'" />
  </div>
  <div class="card-body" style="min-height: 133px !important" *ngIf="!isLoaded">
    <span class="bg-success-transparent icon-service text-success float-end"
      ><i class="fe fe-trending-up"></i
    ></span>
    <h6 class="mb-3">{{ 'common.availableBalance' | translate }}</h6>
    <h4 class="mb-1">
      <span class="number-font"
        >
        <span class="counter">{{
          readyAmount
            | formatCurrency
        }}</span></span
      >
    </h4>
  </div>
</div>
